export const MODULES = {
    PERMISSION: "PERMISSIONS",
    USER: "USER",
    LIST_IMPORT: "IMPORT_WAREHOUSE",
    LIST_EXPORT: "EXPORT_WAREHOUSE"
}
export const ACTION = {
    DELETE: "DELETE",
    CREATE: "CREATE",
    UPDATE: "UPDATE",
}
